const CHECKBOX_CHECKED_LIST = [
  { variant: 'default', label: 'Default', checked: true },
  { variant: 'hover', label: 'Hover', checked: true },
  { variant: 'active', label: 'Active', checked: true },
  { variant: 'focus', label: 'Focus', checked: true },
  { variant: 'disabled', label: 'Disabled', checked: true, disabled: true }
]

export default CHECKBOX_CHECKED_LIST
